const orden_compras = state => state.orden_compras;
const fetch = state => state.fetch;

export default {
orden_compras,
fetch,
};